import { styled } from "@mui/material/styles";
import { FormControl, InputLabel } from "@mui/material";

export const CustomFormControl = styled(FormControl)(({ }) => {
    return {
        width: '100%',
        marginTop: 1,
        borderRadius: '8px',
        '& .MuiInputLabel-root': {
            top: '50%',
            transform: 'translate(14px, -50%) scale(1)',
        },
        '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            top: 0,
            transform: 'translate(14px, -6px) scale(0.75)',
        },
        '.MuiAutocomplete-listbox': {
            scrollbarWidth: 'thin',
            '&::-webkit-scrollbar': {
                width: 5,
            },
        },
    }
})

export const CustomInputLabel = styled(InputLabel)(({ theme }) => {
    return {
        fontSize: '14px',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    }
})